const PORTAL_PREVIEW_STORAGE_KEY = 'portalPreview';

const getSessionStorage = () => {
  if (typeof window === 'undefined') return null;

  try {
    return window.sessionStorage;
  } catch (error) {
    return null;
  }
};

export const getStoredPortalPreview = () => {
  const storage = getSessionStorage();
  if (!storage) return null;

  try {
    const portal = JSON.parse(storage.getItem(PORTAL_PREVIEW_STORAGE_KEY));
    return portal?.id ? portal : null;
  } catch (error) {
    storage.removeItem(PORTAL_PREVIEW_STORAGE_KEY);
    return null;
  }
};

export const storePortalPreview = portal => {
  const storage = getSessionStorage();
  if (!storage || !portal?.id) return;

  storage.setItem(PORTAL_PREVIEW_STORAGE_KEY, JSON.stringify(portal));
};

export const clearStoredPortalPreview = () => {
  const storage = getSessionStorage();
  if (storage) storage.removeItem(PORTAL_PREVIEW_STORAGE_KEY);
};

export { PORTAL_PREVIEW_STORAGE_KEY };
